import React, { useEffect, useState, useMemo } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { message } from 'antd'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { formatTimestamp } from '../../../../utils/format'
import useTitle from '../../../../hooks/useTitle'
import request from '../../../../network/request'
import styles from './index.module.scss'
import Skeleton from '../components/Skeleton'
import { IRemark } from '../../../../network/models/OrderTypes'
import { OP_BTNS } from '../../../../config/index'
import OptModal from '../components/OptModal'
import LookAroundTip from '../components/LookAroundTip'
import { Placeholder } from '../components/Placeholder'
import { getStatusValByKey } from '../common'

const SEE_REMARK_NUM = 2
const SEE_RECORD_NUM = 4
const SEE_ARROUND_IMG_NUM = 5

export default function OrderDetail() {
  useTitle('移动服务单详情')
  const history = useHistory()
  const { orderId } = useParams() as any
  const [orderInfo, setOrderInfo] = useState<any>({})
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [seeMoreRemark, setSeeMoreRemark] = useState<boolean>(false)
  const [seeMoreRecord, setSeeMoreRecord] = useState<boolean>(false)
  const [seeMoreImg, setSeeMoreImg] = useState<boolean>(false)
  const [showOptModal, setShowOptModal] = useState(false)
  const [opType, setOpType] = useState('')
  const [showLookAroundTip, setShowLookAroundTip] = useState(false)

  useEffect(() => {
    if (orderId) {
      getOrderDetail()
    }

    return () => {
      message.destroy()
    }
  }, [orderId])

  const getOrderDetail = async () => {
    setIsLoading(true)
    const loaded = message.loading('加载中...', 0)
    try {
      const orderDetail: any = await request.get(
        '/dragon/service/order/detail',
        {
          params: {
            orderId,
          },
        }
      )
      setOrderInfo(orderDetail)
      setIsError(false)
    } catch (err) {
      setIsError(true)
    } finally {
      loaded()
      setIsLoading(false)
    }
  }

  const orderOpts = useMemo(() => {
    const opts = getStatusValByKey(
      orderInfo.status,
      orderInfo.orderType,
      'optList'
    ) as string
    return opts.length > 0 ? opts.split(',') : []
  }, [orderInfo])

  const lookAroundImgCount = useMemo(() => {
    return orderInfo.surroundCheckDetails?.attachmentList?.length || 0
  }, [orderInfo])

  const linkToLookAround = () => {
    history.push(`/ms/around/${orderId}`)
  }

  const handleLinkToConfirm = () => {
    history.push(`/ms/confirm/${orderId}`)
  }

  const InfoItem = ({
    title,
    children,
  }: {
    title: string
    children: JSX.Element | string
  }) => {
    return (
      <div className={styles.infoItem}>
        <p className={styles.desc}>{title}</p>
        <div className={styles.val}>{children}</div>
      </div>
    )
  }

  const handleCloseOpt = () => {
    setShowOptModal(false)
  }

  const handleRefresh = () => {
    getOrderDetail()
  }

  const handleClickOpt = (event: React.MouseEvent, op: string) => {
    event.stopPropagation()

    if (op === 'finish') {
      handleRequestFinish()
    } else if (op === 'lookaround') {
      setShowLookAroundTip(true)
    } else if (op === 'confirm') {
      handleLinkToConfirm()
    } else {
      setShowOptModal(true)
      setOpType(op)
    }
  }

  const handleRequestFinish = async () => {
    try {
      await request.post('/dragon/service/order/operate', {
        operateType: 'finish',
        serviceOrderId: orderInfo.id,
      })
      setShowOptModal(true)
      setOpType('finish')
    } catch (err) {
      console.log(err)
    }
  }

  const handleCloseLookAround = () => {
    setShowLookAroundTip(false)
  }

  const handleCall = (e) => {
    e.stopPropagation()

    if (window.xdragon) {
      window.xdragon.callHandler('h5callPhone', {
        phone: orderInfo.reserveMobile,
      })
    }
  }

  const handleLinkToDrgon = (e) => {
    e.stopPropagation()

    if (window.xdragon) {
      window.xdragon.callHandler('sendMessage', {
        accId: orderInfo.tid,
        type: 'team',
      })
    }
  }

  const handleNav = (e) => {
    e.stopPropagation()

    if (window.xdragon) {
      window.xdragon.callHandler('openMap', {
        lat: orderInfo.reserveLat,
        lng: orderInfo.reserveLng,
        addr: orderInfo.reserveAddress,
      })
    }
  }

  const handleShowCopied = () => {
    message.destroy()
    message.success('已复制', 1)
  }

  const showDragonLink = useMemo(() => {
    return (
      orderInfo.tid &&
      ((orderInfo.orderType === 'mobile' &&
        orderInfo.status > 1 &&
        orderInfo.status !== 4 &&
        orderInfo.status < 12) ||
        (orderInfo.orderType !== 'mobile' && orderInfo.status < 12))
    )
  }, [orderInfo])

  const Reload = () => {
    return (
      <div className={styles.retryWrap} onClick={getOrderDetail}>
        重试
      </div>
    )
  }

  if (isLoading) {
    return <Skeleton />
  }

  if (isError) {
    return (
      <Placeholder type="error">
        <Reload></Reload>
      </Placeholder>
    )
  }

  return (
    <div className={styles.pageDetail}>
      <div className={styles.headerBlock}>
        <div className={[styles.blockItem, styles.decorate].join(' ')}>
          <div className={styles.customInfo}>
            <div className={styles.nameStatus}>
              <p className={styles.name}>{orderInfo.reserveName}</p>
              <div className={styles.labelContainer}>
                <p className={styles.typeLabel}>
                  {orderInfo.orderType === 'mobile' ? '移动服务' : '远程服务'}•
                  {orderInfo.stationName}
                </p>
                {getStatusValByKey(
                  orderInfo.status,
                  orderInfo.orderType,
                  'label'
                ) && (
                  <p
                    className={[
                      styles.statusLabel,
                      styles[
                        getStatusValByKey(
                          orderInfo.status,
                          orderInfo.orderType,
                          'labelType'
                        )
                      ],
                    ].join(' ')}
                  >
                    {getStatusValByKey(
                      orderInfo.status,
                      orderInfo.orderType,
                      'label'
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className={styles.contact}>
              <p className={styles.mobile} onClick={handleCall}>
                {orderInfo.reserveMobile}
              </p>
              {showDragonLink && (
                <p className={styles.xdragon} onClick={handleLinkToDrgon}></p>
              )}
            </div>
            <div className={styles.address} onClick={handleNav}>
              <div className={styles.iconAddress}></div>
              <p className={styles.addressDetail}>{orderInfo.reserveAddress}</p>
              <div className={styles.iconArrow}></div>
            </div>
          </div>
        </div>
        <div className={styles.blockItem}>
          <div className={styles.orderSummary}>
            <div className={styles.reserveInfo}>
              <p className={styles.reserveTime}>
                预约时间: {orderInfo.reserveTime}
                {orderInfo.orderType !== 'mobile' &&
                  orderInfo.reserveEndTime && (
                    <span> -- {orderInfo.reserveEndTime}</span>
                  )}
              </p>
              {orderInfo.orderType === 'mobile' && (
                <p>服务车辆: {orderInfo.serviceVehiclePlateNo}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.orderInfoItem}>
        <h3 className={styles.title}>订单信息</h3>
        <InfoItem title="订单号">
          <CopyToClipboard text={orderInfo.id} onCopy={handleShowCopied}>
            <p className={styles.orderCodeWrap}>
              <span>{orderInfo.id}</span>
              <span className={styles.copyIcon}></span>
            </p>
          </CopyToClipboard>
        </InfoItem>
        <InfoItem title="派单时间">{orderInfo.dispatchTime}</InfoItem>
        <InfoItem title="预约时间">{orderInfo.reserveTime}</InfoItem>
        <InfoItem title="建单人">{orderInfo.creator}</InfoItem>
      </div>
      <div className={styles.orderInfoItem}>
        <h3 className={styles.title}>车辆信息</h3>
        <InfoItem title="车架号">
          <CopyToClipboard text={orderInfo.vin} onCopy={handleShowCopied}>
            <p className={styles.orderCodeWrap}>
              <span>{orderInfo.vin}</span>
              <span className={styles.copyIcon}></span>
            </p>
          </CopyToClipboard>
        </InfoItem>
        <InfoItem title="车牌">
          {orderInfo.plateNo ? (
            <CopyToClipboard text={orderInfo.plateNo} onCopy={handleShowCopied}>
              <p className={styles.orderCodeWrap}>
                <span>{orderInfo.plateNo}</span>
                <span className={styles.copyIcon}></span>
              </p>
            </CopyToClipboard>
          ) : (
            '--'
          )}
        </InfoItem>
        <InfoItem title="车辆颜色">
            {orderInfo.colour}
        </InfoItem>
        <InfoItem title="车系车型">
          <span>
            {orderInfo.vehicleSeries} / {orderInfo.vehicleModel}
          </span>
        </InfoItem>
        <InfoItem title="版本">{orderInfo.vehicleVersion}</InfoItem>
      </div>
      {orderInfo?.itemDetails?.length > 0 && (
        <div className={styles.orderInfoItem}>
          <h3 className={styles.title}>服务项目</h3>
          <div className={styles.serviceItemsWrap}>
            {orderInfo.itemDetails?.map((item: any) => {
              return (
                <div className={styles.serviceItem} key={item.itemId}>
                  {item.name}
                </div>
              )
            })}
          </div>
        </div>
      )}
      <div className={styles.orderInfoItem}>
        <h3 className={styles.title}>备注</h3>
        <div className={styles.remarkWrap}>
          {orderInfo.remarks?.map((remark: IRemark, remarkIndex: number) => {
            return (
              (remarkIndex < SEE_REMARK_NUM || seeMoreRemark) && (
                <div key={remarkIndex} className={styles.remarkItem}>
                  <div className={styles.markTitle}>
                    <div className={styles.name}>
                      {remark.createName}
                      {remark.createRoleName && (
                        <span className={styles.role}>
                          {remark.createRoleName}
                        </span>
                      )}
                    </div>
                    <div className={styles.time}>
                      {formatTimestamp(remark.createTime)}
                    </div>
                  </div>
                  <p className={styles.remarkContent}>{remark.remark}</p>
                </div>
              )
            )
          })}
          {orderInfo.remarks?.length > SEE_REMARK_NUM && (
            <div
              className={styles.seeMoreWrap}
              onClick={() => setSeeMoreRemark(!seeMoreRemark)}
            >
              {seeMoreRemark ? (
                <>
                  <p className={styles.txt}>收起</p>
                  <div className={styles.upIcon}></div>
                </>
              ) : (
                <>
                  <p className={styles.txt}>查看更多</p>
                  <div className={styles.downIcon}></div>
                </>
              )}
            </div>
          )}
          {orderInfo.status < 12 && (
            <div
              className={styles.addRemark}
              onClick={(e) => handleClickOpt(e, 'addRemark')}
            >
              <div className={styles.drawIcon}></div>
              <p className={styles.desc}>输入备注信息</p>
            </div>
          )}
        </div>
      </div>
      {orderInfo.status > 5 && (
        <div className={styles.orderInfoItem}>
          <div className={styles.orderInfoHeader}>
            <h3 className={styles.title}>环车检查详情</h3>
            <p className={styles.link} onClick={linkToLookAround}>
              查看详情
            </p>
          </div>
          <div className={styles.lookAroundWrap}>
            <div className={styles.imageWrap} onClick={linkToLookAround}>
              {lookAroundImgCount > 0
                ? orderInfo.surroundCheckDetails?.attachmentList?.map(
                    (image: any, imageIndex: number) => {
                      return (
                        (imageIndex < SEE_ARROUND_IMG_NUM || seeMoreImg) && (
                          <div
                            className={styles.imageContainer}
                            key={imageIndex}
                          >
                            <img
                              className={styles.arroundImg}
                              src={image?.url}
                              alt=""
                            />
                          </div>
                        )
                      )
                    }
                  )
                : orderInfo.status < 12 && (
                    <div className={styles.addImgPlacehold}>
                      <div className={styles.addIcon}></div>
                    </div>
                  )}
            </div>
            {lookAroundImgCount > SEE_ARROUND_IMG_NUM && (
              <div
                className={styles.seeMoreWrap}
                onClick={() => setSeeMoreImg(!seeMoreImg)}
              >
                {seeMoreImg ? (
                  <>
                    <p className={styles.txt}>
                      共 {lookAroundImgCount}
                      /9 张照片
                    </p>
                    <div className={styles.upIcon}></div>
                  </>
                ) : (
                  <>
                    <p className={styles.txt}>
                      共 {lookAroundImgCount} /9 张照片
                    </p>
                    <div className={styles.downIcon}></div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {orderInfo?.workOrderDetails?.repairOrderCode && (
        <div className={styles.orderInfoItem}>
          <h3 className={styles.title}>关联服务单</h3>
          <InfoItem title="OAS工单号">
            <CopyToClipboard
              text={orderInfo.workOrderDetails?.repairOrderCode}
              onCopy={handleShowCopied}
            >
              <p className={styles.orderCodeWrap}>
                <span>{orderInfo.workOrderDetails?.repairOrderCode}</span>
                <span className={styles.copyIcon}></span>
              </p>
            </CopyToClipboard>
          </InfoItem>
          {orderInfo.workOrderDetails.balanceCode?.map(
            (balance: string, index: number) => {
              return (
                <InfoItem title={`OAS结算工单号${index + 1}`} key={index}>
                  <CopyToClipboard text={balance} onCopy={handleShowCopied}>
                    <p className={styles.orderCodeWrap}>
                      <span>{balance}</span>
                      <span className={styles.copyIcon}></span>
                    </p>
                  </CopyToClipboard>
                </InfoItem>
              )
            }
          )}
        </div>
      )}
      {orderInfo.details && orderInfo.details?.length > 0 && (
        <div className={[styles.orderInfoItem, styles.noBorder].join(' ')}>
          <h3 className={styles.title}>服务记录</h3>
          <div className={styles.recordWrap}>
            {orderInfo.details?.map((detail: any, detailIndex: number) => {
              return (
                (detailIndex < SEE_RECORD_NUM || seeMoreRecord) && (
                  <div className={styles.recordItem} key={detailIndex}>
                    <p className={styles.recordTitle}>{detail.tips}</p>
                    <p className={styles.recordTime}>
                      {formatTimestamp(detail.createTime)}
                    </p>
                  </div>
                )
              )
            })}
          </div>
          {orderInfo.details?.length > SEE_RECORD_NUM && (
            <div
              className={styles.seeMoreWrap}
              onClick={() => setSeeMoreRecord(!seeMoreRecord)}
            >
              {seeMoreRecord ? (
                <>
                  <p className={styles.txt}>收起</p>
                  <div className={styles.upIcon}></div>
                </>
              ) : (
                <>
                  <p className={styles.txt}>查看更多</p>
                  <div className={styles.downIcon}></div>
                </>
              )}
            </div>
          )}
        </div>
      )}
      {orderOpts?.length > 0 && (
        <div className={styles.optWrap}>
          {orderOpts.map((op) => {
            return (
              op && (
                <div
                  key={op}
                  className={[styles.opBtn, styles[op]].join(' ')}
                  onClick={(e) => handleClickOpt(e, op)}
                >
                  <div className={styles.icon}></div>
                  <p> {OP_BTNS[op as keyof typeof OP_BTNS]}</p>
                </div>
              )
            )
          })}
        </div>
      )}

      {showOptModal && (
        <OptModal
          opType={opType}
          order={orderInfo}
          onClose={handleCloseOpt}
          onRefreshData={handleRefresh}
        ></OptModal>
      )}
      {showLookAroundTip && (
        <LookAroundTip
          order={orderInfo}
          onClose={handleCloseLookAround}
        ></LookAroundTip>
      )}
    </div>
  )
}
